module.exports = __webpack_public_path__ + "static/media/novanector.1ecf8228.png";